module.exports = require('./helpers/bundle-url').getBundleURL('kBF18') + "logo-dark.eefe0b7f.svg";